import { FC } from 'react';
import type { RowProps } from '../Row';
import Row from '../Row';

interface CalloutBodyProps extends RowProps {}

const CalloutBody: FC<CalloutBodyProps> = ({ children, ...props }) => {
    return (
        <Row justifyContent="center" alignItems="center" sx={{ p: 3 }} {...props}>
            {children}
        </Row>
    );
};

export type { CalloutBodyProps };
export default CalloutBody;
